/**
 * @generated SignedSource<<b2844bdc90ae7636082cfb6a945f1c65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentRow_payment$data = {
  readonly amount: number;
  readonly createdAt: string | null;
  readonly details: string | null;
  readonly id: string;
  readonly paymentDate: string | null;
  readonly user: {
    readonly name: string;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentStatus_payment" | "PaymentType_payment">;
  readonly " $fragmentType": "PaymentRow_payment";
};
export type PaymentRow_payment$key = {
  readonly " $data"?: PaymentRow_payment$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentRow_payment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentRow_payment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "details",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentType_payment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentStatus_payment"
    }
  ],
  "type": "Payment",
  "abstractKey": null
};

(node as any).hash = "cc7b8a7d561ff773e1025d5f438c0ec1";

export default node;
